// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ATHX","buttons":"styles_buttons__2yPrw"};